import { MaintenanceType } from '@superbet-group/web.types';

export const mebbMaintenanceConfig = {
    applicableTypes: [MaintenanceType.Prematch],
    message: 'Part of the offer is unavailable during this maintenance',
};
